import React, { useState } from 'react'
import "./btn.css"

const FilterButton = ({ name, isSelected, handleFilterItemClick }) => {

   return (
      <div className='filter'
         onClick={()=>handleFilterItemClick(name, isSelected)} style={isSelected ? { backgroundColor: '#35F9CA', border: '1px solid black' } : {}}
      >
         <span>{name}</span>
      </div>
   )
}

export default FilterButton